<mat-tree [dataSource]="nodeTree$ | async" [treeControl]="treeControl" class="sidebar-menu">
	<!-- This is the tree node template for leaf nodes -->
	<mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
		<div class="mat-tree-node">
			<!-- use a disabled button to provide padding for tree leaf -->
			<a [routerLink]="node.link" (click)="toggleNode(node)">
				<button tabindex="-1" aria-hidden="true" mat-icon-button [disableRipple]="true">
					<mat-icon *ngIf="node.icon" [svgIcon]="node.icon" class="icon" [ngClass]="isActive(node)">
					</mat-icon>
				</button>
				<span class="item-name">{{ node.name }}</span>
			</a>
		</div>
	</mat-tree-node>
	<!-- This is the tree node template for expandable nodes -->
	<mat-nested-tree-node role="group" *matTreeNodeDef="let node; when: hasChild">
		<!-- <li> -->
		<div class="mat-tree-node">
			<button mat-icon-button [disableRipple]="true" matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
				<mat-icon *ngIf="node.icon" [svgIcon]="node.icon" class="icon" [ngClass]="isActive(node)"> </mat-icon>
				<mat-icon *ngIf="!node.icon" class="mat-icon-rtl-mirror icon" [ngClass]="isActive(node)">
					{{ treeControl.isExpanded(node) ? 'expand_less' : 'chevron_right' }}
				</mat-icon>
			</button>
			<span *ngIf="node.isRoot" class="item-name" (click)="toggleNode(node)">
				{{ node.name }}
			</span>
			<a *ngIf="!node.isRoot" class="item-name" [routerLink]="node.link" (click)="toggleNode(node)">
				{{ node.name }}
			</a>
		</div>
		<ul role="group" class="mat-tree-expanded" [@slideVertical]="treeControl.isExpanded(node) ? 'show' : null">
			<ng-container matTreeNodeOutlet></ng-container>
		</ul>
		<!-- </li> -->
	</mat-nested-tree-node>
</mat-tree>
